import * as React from 'react';
import clsx from 'clsx';

import { useFeatureFlag } from '@tock/shared/utils/featureFlagContext';
import ScrollLockComponent from '@tock/shared/components/ScrollLockComponent';

interface Props {
  children?: React.ReactNode;
  modifierClassName?: string;
  scrollContextClassName?: string;
}
/**
 * @deprecated Use ui/DialogContent with ui/Dialog instead
 */
function ComposableModalBody(props: Props) {
  const { children, modifierClassName, scrollContextClassName } = props;
  const className = clsx('ComposableModalBody', modifierClassName, scrollContextClassName);

  const removeCompositeLayer = useFeatureFlag('UI_LAYER_COMPOSITING');

  return (
    <ScrollLockComponent removeCompositeLayer={removeCompositeLayer} className={className}>
      {children}
    </ScrollLockComponent>
  );
}

export default ComposableModalBody;
